export default {"src":"/_next/static/media/nevo-advisory-logo.39023786.svg","height":97,"width":266};